import {
  SAVE_EVENT_STARTED,
  SAVE_EVENT_COMPLETED,
  SAVE_EVENT_FAILED,
  GET_EVENT_STARTED,
  GET_EVENT_COMPLETED,
  GET_EVENT_FAILED,
  UPDATE_EVENT_STARTED,
  UPDATE_EVENT_COMPLETED,
  UPDATE_EVENT_FAILED
  } from '../actions/UpEvent';
  
  const upcomingeventDataData = {
      status: {
        statusCode: 300,
        statusDisplay: "",
        statusValue: true
      },
      items: [],
      userInput: {
        insert_datetime:"",
        inserted_by:"",
        update_datetime:"",
        updated_by:""
    
      },
      isLoading: true,
      isListLoading:true,
      isFormSubmit: false,
      isLoggedIn: false,
      error: '',
      userList:[]
    };
  
    export const upcomingeventData = (state = upcomingeventDataData, action: any) => {
      
  
      switch (action.type) {
  
  
  
  
  case SAVE_EVENT_STARTED:
          return {
            ...state,
            items:[],
            isLoading: true,
          };
    
        case SAVE_EVENT_COMPLETED:
        
          return {
            ...state,
            isLoading: false,
            status: action.status,
            items: action.payload
          };
    
        case SAVE_EVENT_FAILED:
          return {
            ...state,
            isLoading: true,
          };
          
           
           
            default:
                return state;
      } 
  };
  export const GETupcomingeventData = (state = upcomingeventDataData, action: any) => {
    switch (action.type) {
    case GET_EVENT_STARTED:  
    return {
      ...state,
      items:[],
      isLoading: true,
    };
  case GET_EVENT_COMPLETED:
    return {
      ...state,
      isLoading: false,
      status: action.status,
      items: action.payload
    };
  case GET_EVENT_FAILED:
    return {
      ...state,
      isLoading: true,
    };
    default:
      return state;
  }
  }
  export const UPDATEeventData = (state = upcomingeventDataData, action: any) => {
   // alert("reducer UPDATEeventData");
    switch (action.type) {
  
  
  
  
  case UPDATE_EVENT_STARTED:
        return {
          ...state,
          items:[],
          isLoading: true,
        };
  
      case UPDATE_EVENT_COMPLETED:
      
        return {
          ...state,
          isLoading: false,
          status: action.status,
          items: action.payload
        };
  
      case UPDATE_EVENT_FAILED:
        return {
          ...state,
      isLoading: true,
        };
        
         
         
          default:
              return state;
    } 
  };